import { forwardRef } from 'react'

import { SvgIcon, SvgIconProps } from '@mui/material'

// Skull icon from Phosphor Icons (MIT): https://phosphoricons.com
export const DiscontinuedSkullIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon viewBox="0 0 256 256" ref={ref} {...props}>
    <path d="M128,16C70.65,16,24,60.86,24,116c0,34.1,18.27,66,48,84.28V216a16,16,0,0,0,16,16h8a4,4,0,0,0,4-4V200.27a8.17,8.17,0,0,1,7.47-8.25,8,8,0,0,1,8.53,8v28a4,4,0,0,0,4,4h16a4,4,0,0,0,4-4V200.27a8.17,8.17,0,0,1,7.47-8.25,8,8,0,0,1,8.53,8v28a4,4,0,0,0,4,4h8a16,16,0,0,0,16-16V200.28C213.73,182,232,150.1,232,116,232,60.86,185.35,16,128,16ZM92,152a20,20,0,1,1,20-20A20,20,0,0,1,92,152Zm72,0a20,20,0,1,1,20-20A20,20,0,0,1,164,152Z" />
  </SvgIcon>
))

DiscontinuedSkullIcon.displayName = 'DiscontinuedSkullIcon'
